import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography } from '@telus-uds/components-web';

import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing from '../../utils';
import Row from './row';

const Table = ({
  viewType,
  additionalServices,
  setAdditionalServices,
  list,
  total,
  setTotal
}) => {
  const getHeader = headerList => (
    <Thead>
      <Tr>
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const grandTotal = Object.keys(additionalServices).reduce(
      (acc, current) => {
        const { unitPrice, quantity } = additionalServices[current];
        return acc + unitPrice * +quantity;
      },
      0
    );
    setTotal(previousValue => ({
      ...previousValue,
      additionalServices: grandTotal
    }));
  }, [additionalServices]);
  return (
    <table>
      {list.map(additionalService =>
        _.get(additionalService, 'fields.isHeader', false) ? (
          getHeader(_.get(additionalService, 'fields.headerList', []))
        ) : (
          <Row
            key={additionalService.addonName}
            rowData={additionalService}
            viewType={viewType}
            additionalServices={additionalServices}
            setAdditionalServices={setAdditionalServices}
          />
        )
      )}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={3}>
          <Typography variant={{ bold: true }}>Total</Typography>
        </Td>
        <Td>
          <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  viewType: PropTypes.string.isRequired,
  additionalServices: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAdditionalServices: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Table;
